import { type RouteObject } from 'react-router';
import { standaloneLayout } from '@/app/layouts';
import { parseSearchLoader, unauthorizedSearchSchema } from '@/shared/navigation';
import { ROUTES } from '@/shared/routing';

/** 에러 화면 — not-found · maintenance · unauthorized (`/error/*`). StandaloneLayout chrome. */
export function createErrorRoute(): RouteObject {
  return {
    element: standaloneLayout({ width: 'full' }), // TODO: 라우트별 width 값 지정 ('sm'|'md'|'lg'|'full')
    path: ROUTES.ERROR,
    children: [
      // bare `/error` → NotFound
      {
        index: true,
        lazy: { Component: () => import('@/pages/error/not-found').then((m) => m.NotFoundPage) },
      },
      {
        path: ROUTES.ERROR_MAINTENANCE,
        lazy: {
          Component: () => import('@/pages/error/maintenance').then((m) => m.MaintenancePage),
        },
      },
      {
        path: ROUTES.ERROR_UNAUTHORIZED,
        loader: parseSearchLoader(unauthorizedSearchSchema),
        lazy: {
          Component: () => import('@/pages/error/unauthorized').then((m) => m.UnauthorizedPage),
        },
      },
    ],
  };
}
